import React from 'react';
import about_image from '../../assets/images/Lucie-Skokanova.jpg';
import Headline from '../../partials/Headline';
import Text from '../../partials/Text';
import Divider from '../../partials/Divider';
import GuidePost from '../../components/GuidePost';

import routes from '../../routes.json';
import aroma_red from '../../assets/images/icons/aroma_red.svg';
import massage_white from '../../assets/images/icons/massage_white.svg';
import wellness_blue from '../../assets/images/icons/wellness_blue.svg';

const posts = [
  {
    backgroundColor: '#F3E4DF',
    textColor: '#651E38',
    route: routes.AROMATHERAPY,
    title: 'Aromaterapie',
    imageUrl: aroma_red,
    imageAlt: 'aromatherapy',
    btnText: 'Více',
  },
  {
    backgroundColor: '#AEC2B9',
    textColor: '#FFFFFF',
    route: routes.MASSAGE,
    title: 'Masáže',
    imageUrl: massage_white,
    imageAlt: 'masáž',
    btnText: 'Více',
  },
  {
    backgroundColor: '#DBE2E6',
    textColor: '#104366',
    route: routes.WELLNESS,
    title: 'Wellness',
    imageUrl: wellness_blue,
    imageAlt: 'wellness',
    btnText: 'Více',
  }
]

const AboutPage = () => {
  return (
    <div className="page page-about">
      <div className="container container_narrow"> 
        <Headline h={1}>
          O mně
        </Headline>
        <section className="page-section section-about">
          <div className="row">
            <div className="col">
              <Text className="text_big">
                Jmenuji se Lucie Skokanová, jsem profesionální aromaterapeutka. Od&nbsp;roku 2014 se věnuji aromaterapii ve své praxi, kde nabízím různé druhy masáží, konzultací a aromaterapeutických výrobků dle individuálních potřeb.
              </Text>
            </div>
            <div className="col">
              <div className="double-frame">
                <img src={about_image} alt="Lucie Skokanová" className="about-image" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Text>
                Pro klienty, kteří vyžadují k aromaterapii z různých důvodů informační servis, tvořím vzdělávací programy či doporučení dle jejich požadavků. Jsem certifikovanou lektorkou pro „Základní kurz aromaterapie“ pro Asociací českých aromaterapeutů.
              </Text>
              <Text>
                Aromaterapie je cílené užití esenciálních olejů za určitým účelem. Je nutno podotknout, že esenciální olej není tím, co se nachází v rostlině. Vždy se jedná o složitou chemickou sloučeninu. A nakládání s těmito substancemi podléhá pravidlům, které při nedodržení, může ohrozit zdraví člověka či zvířete. Toliko a mnoho dalších informací můžete nalézt na různých webech, přečíst si v knihách nebo získat na školeních.
              </Text>
              <Text className="text_big">
                ... a čím je aromaterapie pro mne?
              </Text>
              <Text>
                Další úroveň světa?... vůně je pro mne nejen čichový vjem, je to i informace kterou nese, potvrzení domněnky, nástroj k regeneraci, odpovědnost a především radost i kouzlo. Pokud se tímto způsobem dá kvalifikovat srdeční záležitost ..... pak je aromaterapie pro mne srdeční záležitostí, která se mi prolíná životem.
              </Text>
              <Text>
                Mám ráda život, uvědomuju si jeho proměny, cítím je a prožívám. Jsem vdaná, mám dvě dospívající děti a v současné době žiji v Praze a na Šumavě. Pro mne každé místo, situace, tvor nebo věc, má svou vůni. Někdy je pociťuji ráda, jindy je nesu ne zrovna s velkým nadšením, ostatně jako každý člověk.
              </Text>
              <Text>
                Tyto stránky jsem vytvořila jako svou prodlouženou vizitku a zároveň místo, kde budu představovat aromaterapii v praxi.
              </Text>
              <Divider />
            </div>
          </div>
        </section>
      </div>
      <div className="container">
        <GuidePost posts={posts} />
      </div>
    </div>
  );
}

export default AboutPage;